import { FormDialog, FormDialogProps } from '@kirz/mui-admin';
import { Box, MenuItem, Select, Stack, Typography } from '@mui/material';
import React, { useContext, useState } from 'react';

import { UserContext } from 'contexts';
import { SettingsContext } from 'contexts/SettingsContext';
import { ClientFormFields } from 'pages/Client/ClientFormFields';
import { useClientFormPreSubmit } from 'pages/Client/useClientFormPreSubmit';

export function NewClientDialog(props: Partial<FormDialogProps>) {
  const [existingClient, setExistingClient] = useState<any>(null);
  const [clientType, setClientType] = useState<'individual' | 'legal'>(
    'individual',
  );
  const { user } = useContext(UserContext);
  const { leadSources } = useContext(SettingsContext);
  const preSubmit = useClientFormPreSubmit(setExistingClient, clientType);
  const { ...rest } = props;

  return (
    <FormDialog
      {...(rest as any)}
      source={rest.source ?? 'client'}
      title={
        <Box display="flex" alignItems="center" gap={5}>
          <Typography variant="h6">Новый клиент</Typography>
          <Select
            name="type"
            value={clientType}
            onChange={(e) =>
              setClientType(e.target.value as 'individual' | 'legal')
            }
            size="small"
          >
            <MenuItem value="individual">Физическое лицо</MenuItem>
            <MenuItem value="legal">Юридическое лицо</MenuItem>
          </Select>
        </Box>
      }
      maxWidth={rest.maxWidth ?? 'md'}
      autoFocus={false}
      formProps={{
        defaultValues: {
          type: 'individual',
          gender: 'male',
          userId: user.id,
          ...props?.formProps?.defaultValues,
        },
      }}
      formSubmitterProps={{
        preSubmit,
      }}
    >
      <ClientFormFields
        existingClient={existingClient}
        leadSources={leadSources}
        disablePhone={!!props?.formProps?.defaultValues?.phone}
        type={clientType}
      />
    </FormDialog>
  );
}
